import { createSelector } from 'reselect'
import { SettingsRootState } from '../root.reducer'

export const getConfiguration = createSelector(
  (state: SettingsRootState) => state.settingsStore.configuration,
  (state) => state,
)

export const getTheme = createSelector(
  (state: SettingsRootState) => state.settingsStore.theme,
  (state) => state,
)

export const getMessage = createSelector(
  (state: SettingsRootState) => state.settingsStore.message,
  (state) => state,
)

export const getUser = createSelector(
  (state: SettingsRootState) => state.settingsStore.user,
  (state) => state,
)

export const isAuthorized = createSelector(
  (state: SettingsRootState) => state.settingsStore.isAuthorized,
  (state) => state,
)

export const isFetching = createSelector(
  (state: SettingsRootState) => state.settingsStore.fetching,
  (state) => state,
)
